import React, { useState } from "react";
import CompoundCircles from "../assets/images/compound-1.svg";
import EmailModal from "./EmailModal";
import { saveEmail } from "../api/emails";

const FooterCTA: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDownloadClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleEmailSubmit = async (email: string) => {
    await saveEmail(email);
    const link = document.createElement("a");
    link.href = "/cchub-impact-report.pdf";
    link.download = "CcHUB 2025 Impact Report.pdf";
    link.click();
  };

  return (
    <>
      <section id="footer-cta">
        <div className="footer-container">
          <div className="footer-content-left">
            <h2>
              <span className="yellow-highlight">25,000 people supported,</span>
              <br />
              <span className="yellow-highlight">
                1.89 million served by the
              </span>
              <br />
              <span className="yellow-highlight">ventures we back.</span>
            </h2>
            <p>
              Between those two numbers is the story of how an innovation
              ecosystem actually works.
            </p>
            <a href="#" onClick={handleDownloadClick}>
              <button className="download-btn">
                Download the 2025 Impact Report
              </button>
            </a>
          </div>

          <div className="footer-content-right">
            <img
              src={CompoundCircles}
              alt="Impact visualization"
              className="footer-visual"
            />
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 Co-creation HUB Ltd</p>
        </div>
      </section>
      <EmailModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleEmailSubmit}
      />
    </>
  );
};

export default FooterCTA;
